import type { BvBill } from '../types/billTypes';

/**
 * The single rule that decides whether environmental charges are shown in a bill
 * validation comparison. A site's environmental section is only meaningful when
 * the customer has GreenPower — otherwise the environmental charges are excluded
 * from the comparison (Job 21), matching what the customer-facing report already
 * did with its local `hasGreenPower` check.
 *
 * Reads `bv_extn.green_power`. Returns false for a missing site or missing
 * bv_extn, so callers can pass `bill.site` directly.
 */
export function showsEnvironmental(site: BvBill['site']): boolean {
  return !!site?.bv_extn?.['green_power'];
}
